var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTele(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.42 12.42 16 8 16C3.58 16 0 12.42 0 8C0 3.58 3.58 0 8 0C12.42 0 16 3.58 16 8Z",
    fill: "url(#paint0_linear_1708_8548)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53346 11.6672C6.27346 11.6672 6.32013 11.5672 6.2268 11.3205L5.4668 8.81385L10.1868 5.86719L10.7401 6.01385L10.2801 7.26719L6.53346 11.6672Z",
    fill: "#C8DAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5332 11.6674C6.7332 11.6674 6.81987 11.5741 6.9332 11.4674C7.10654 11.3008 9.3332 9.13411 9.3332 9.13411L7.96654 8.80078L6.69987 9.60078L6.5332 11.6008V11.6674Z",
    fill: "#A9C9DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 9.62604L9.89329 12.006C10.26 12.206 10.5266 12.106 10.62 11.666L11.9333 5.47938C12.0666 4.93938 11.7266 4.69938 11.3733 4.85938L3.66663 7.83271C3.13996 8.04605 3.14663 8.33938 3.57329 8.46605L5.55329 9.08605L10.1333 6.19938C10.3466 6.06605 10.5466 6.13938 10.3866 6.28605L6.66663 9.62604Z",
    fill: "url(#paint1_linear_1708_8548)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1708_8548",
    x1: 10.3447,
    y1: 2.52867,
    x2: 6.34467,
    y2: 11.8619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1708_8548",
    x1: 8.59936,
    y1: 8.24971,
    x2: 10.266,
    y2: 10.9164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTele);
export default __webpack_public_path__ + "static/media/tele.1f9ebbf0ac843e252cdc8f8f17d26895.svg";
export { ForwardRef as ReactComponent };